import { PropsWithChildren } from 'react';

import { ModificationDenyTooltip } from '@components/IsModificationAllowed/components/ModificationDenyTooltip';

type IsModificationAllowedProps = {
  allowed?: boolean;
  tooltip?: string;
} & PropsWithChildren;

export const IsModificationAllowed = ({
  allowed = true,
  tooltip,
  children,
}: IsModificationAllowedProps) => {
  if (allowed) {
    return children;
  }

  return (
    <ModificationDenyTooltip tooltip={tooltip}>
      {children}
    </ModificationDenyTooltip>
  );
};
